import React, { useState } from "react";
import PropTypes from "prop-types";

const ExplanationApp = (props) => {
    const [result, setResult] = useState();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const explainText = async () => {
        const text = document.getElementById('explanation-text').value;
        
        if (!text) {
            alert('Please enter some text.');
            return;
        }

        setError(false);
        setResult();
        setLoading(true);
        const response = await fetch(
            props.explanationApiEndpoint,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ "message": text, "model_name": "mistral" })
            }
        );
        const data = await response.json();
        setLoading(false);

        if (data.error)
            setError(true);
        else {
            setResult({
                generatedText:  data.generated_text,
                label: data.label,
                prob: data.prob
            });
        }
    };
    
    return <form id="explanation-form">
        <div className = "card bg-secondary bg-opacity-75 p-4 text-light">
            <h2>Explain Hateful Message</h2>
            <p className = "fst-italic">Enter the text in the box below to explain why the inserted text is hateful or not.</p>
            <div className = "form-floating">
                <textarea
                    className = "form-control"
                    id = "explanation-text"
                    placeholder = "Enter text here..."
                    maxLength = { 1024 }
                    style = {{ minHeight: 100 }}
                    required
                >
                    { props.explanationExample }
                </textarea>
                <label className = "text-muted fs-6" htmlFor="explanation-text">Input text</label>
            </div>
            <p className = "mt-3 text-center">
                {
                    loading ?
                        <span className = "spinner-border" role = "status">
                            <span className = "visually-hidden">Loading...</span>
                        </span> :
                        null
                }
                { error ? <span className = "text-danger fw-bold">An error occurred with this text</span> : null }
                {
                    result ? <>
                        <span className = "mb-2">The insterted text is { result.label } with a probability of { result.prob }</span><br/>
                        <span>{ result.generatedText }</span>
                    </> :
                    null
                }
            </p>
        </div>
        <div className = "my-3 text-center" id = "explanation-model">
            <button type = "button" className = "btn btn-lg btn-secondary text-light" onClick = { explainText }>
                Explain text
            </button>
        </div>
    </form>;
};

ExplanationApp.propTypes = {
    explanationExample: PropTypes.string,
    explanationApiEndpoint: PropTypes.string
};

export default ExplanationApp;